<div class="modal cookies">
  <div class="modal__top">
    <span class="modal__title">{{ 'FOOTER.COOKIES_POLICY' | i18nextEager | uppercase }}</span>
    <img
      (click)="closeModal()"
      src="/assets/icons/close_modal.svg"
      class="modal__click"
      alt="{{ 'COMMONS.CLOSE' | i18nextEager }}"
    />
  </div>
  <div class="modal__body">
    <h1>{{ 'COOKIES.ABOUT.TITLE' | i18nextEager | uppercase }}</h1>
    <p>{{ 'COOKIES.ABOUT.P1' | i18nextEager }}</p>
    <p>{{ 'COOKIES.ABOUT.P2' | i18nextEager }}</p>
    <p>{{ 'COOKIES.ABOUT.P3' | i18nextEager }}</p>
    <p>{{ 'COOKIES.ABOUT.P4' | i18nextEager }}</p>

    <h1>{{ 'COOKIES.USED.TITLE' | i18nextEager | uppercase }}</h1>
    <p>{{ 'COOKIES.USED.P1' | i18nextEager }}</p>

    <p>{{ 'COOKIES.USED.P2.TITLE' | i18nextEager }}</p>
    <div class="indent">
      <p>
        <strong>{{ 'COOKIES.USED.P2.I1' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P2.P1' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P2.I2' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P2.P2' | i18nextEager }}
      </p>
    </div>

    <p>{{ 'COOKIES.USED.P3.TITLE' | i18nextEager }}</p>
    <div class="indent">
      <p>
        <strong>{{ 'COOKIES.USED.P3.I1' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P3.P1' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P3.I2' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P3.P2' | i18nextEager }}
      </p>
    </div>

    <p>{{ 'COOKIES.USED.P4.TITLE' | i18nextEager }}</p>
    <div class="indent">
      <p>
        <strong>{{ 'COOKIES.USED.P4.I1' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P4.P1' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P4.I2' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P4.P2' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P4.I3' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P4.P3' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P4.I4' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P4.P4' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.USED.P4.I5' | i18nextEager }}</strong
        >{{ 'COOKIES.USED.P4.P5' | i18nextEager }}
      </p>
    </div>

    <div #body></div>

    <h1>{{ 'COOKIES.DISABLE.TITLE' | i18nextEager | uppercase }}</h1>
    <p>{{ 'COOKIES.DISABLE.P1' | i18nextEager }}</p>
    <p>{{ 'COOKIES.DISABLE.P2' | i18nextEager }}</p>
    <div class="indent">
      <p>
        <strong>{{ 'COOKIES.DISABLE.I1' | i18nextEager }}</strong
        >{{ 'COOKIES.DISABLE.T1_START' | i18nextEager
        }}<a
          href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
          target="_blank"
          >{{ 'COOKIES.DISABLE.T1_SUPPORT' | i18nextEager }}</a
        >{{ 'COOKIES.DISABLE.T1_END' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.DISABLE.I2' | i18nextEager }}</strong
        >{{ 'COOKIES.DISABLE.T2_START' | i18nextEager
        }}<a
          href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
          target="_blank"
          >{{ 'COOKIES.DISABLE.T2_SUPPORT' | i18nextEager }}</a
        >{{ 'COOKIES.DISABLE.T2_END' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.DISABLE.I3' | i18nextEager }}</strong
        >{{ 'COOKIES.DISABLE.T3_START' | i18nextEager
        }}<a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es" target="_blank">{{
          'COOKIES.DISABLE.T3_SUPPORT' | i18nextEager
        }}</a
        >{{ 'COOKIES.DISABLE.T3_END' | i18nextEager }}
      </p>
      <p>
        <strong>{{ 'COOKIES.DISABLE.I4' | i18nextEager }}</strong
        >{{ 'COOKIES.DISABLE.T4_START' | i18nextEager
        }}<a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank">{{
          'COOKIES.DISABLE.T4_SUPPORT' | i18nextEager
        }}</a
        >{{ 'COOKIES.DISABLE.T4_END' | i18nextEager }}
      </p>
    </div>
    <p>{{ 'COOKIES.DISABLE.P3' | i18nextEager }}</p>
    <p>{{ 'COOKIES.DISABLE.P4' | i18nextEager }}</p>
    <p>
      {{ 'COOKIES.DISABLE.P5' | i18nextEager }}
      <a href="mailto:protecciondedatosenergia@acciona.com">{{ 'COOKIES.DISABLE.P5_LINK' | i18nextEager }}</a
      >.
    </p>

    <h1>{{ 'COOKIES.UPDATE.TITLE' | i18nextEager }}</h1>
    <p>{{ 'COOKIES.UPDATE.P1' | i18nextEager }}</p>
    <p>
      {{ 'COOKIES.UPDATE.P2' | i18nextEager }}
      <span (click)="openPrivacy()"> {{ 'COOKIES.UPDATE.LINK' | i18nextEager }} </span>.
    </p>
  </div>
</div>
